import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <div>
      <Seo
        title="Page Not Found"
        description="The requested SDRC Global page could not be found. Explore our millet export, product and buyer resource pages."
        noindex
        canonical={false}
      />
      <section className="min-h-[70vh] bg-brand-cream pt-36 pb-24 flex items-center">
        <div className="max-w-[900px] mx-auto px-5 md:px-10 text-center">
          <span className="text-xs uppercase tracking-[0.2em] text-brand-gold-dark font-semibold">404</span>
          <h1 className="font-display text-5xl md:text-7xl font-medium text-brand-green mt-4">This page is not available.</h1>
          <p className="text-brand-muted leading-relaxed max-w-xl mx-auto mt-6">The address may be incorrect or the page may have moved. Continue to our millet export guide or product catalogue.</p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mt-9">
            <Link to="/millet-export" className="inline-flex items-center justify-center gap-2 bg-brand-green text-white px-6 py-3 rounded-full font-semibold hover:bg-brand-green-dark transition-colors">
              Millet export guide <ArrowRight size={16} />
            </Link>
            <Link to="/products" className="inline-flex items-center justify-center gap-2 border border-brand-green text-brand-green px-6 py-3 rounded-full font-semibold hover:bg-brand-green hover:text-white transition-colors">
              <ArrowLeft size={16} /> View products
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
